import createPalette, {
  PaletteOptions,
} from '@material-ui/core/styles/createPalette'

const palette: PaletteOptions = {
  primary: {
    light: '#EDF5F9',
    main: '#1070B0',
    dark: '#88B8D8',
    contrastText: '#EAF1F0',
  },
  secondary: {
    light: '#F7F7F7',
    main: '#615E5E',
    dark: '#35363A',
    contrastText: '#FFF',
  },
  error: {
    main: '#B00000',
    light: '#FBF2F2',
    contrastText: '#B0000090',
  },
  warning: {
    main: '#DE5B00',
    light: '#FFFEF7',
  },
  background: {
    default: '#F9F9F9',
  },
  text: {
    disabled: '#AEAEAE',
  },
  info: {
    main: '#1877F2',
    contrastText: '#4F4F4F',
    light: '#F8FBFD',
  },
  grey: {
    50: '#3D3D3D',
    100: '#626262',
    200: '#DCDCDC',
    300: '#E8E8E8',
    500: '#FCFCFC',
    A100: '#979797',
  },
  success: {
    light: '#E9F4EC',
    dark: '#5DD987',
    main: '#1F8D44',
    contrastText: '#E9F9EC',
  },
}

export default createPalette(palette)
